










import { Vue, Component, Watch } from 'vue-property-decorator'
import { setBackRefrsh, initBlurActive, isAndroidApp } from '@utils/index'
@Component
export default class App extends Vue {
  isRouterAlice = true
  hzwAndroid = isAndroidApp();
  mounted() {
    setBackRefrsh(() => {
      if (!this.$route.meta.keepAlive) this.reload()
    })
    initBlurActive()
    // this.$watch('$route', (to, from) => {
    //   if (to.name !== 'scenicTourism') {
    //     // 为解决添加vue-waterfall2组件的页面 html，body高度100%无法触发loadmore事件问题
    //     document.getElementsByTagName('body')[0].className = 'home'
    //     document.getElementsByTagName('html')[0].className = 'home'
    //   } else {
    //     document.getElementsByTagName('body')[0].className = ''
    //     document.getElementsByTagName('html')[0].className = ''
    //   }
    // })
  }
  reload() {
    this.isRouterAlice = false
    this.$nextTick(() => {
      this.isRouterAlice = true
    })
  }
}
